import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';

import Vini from "./Pages/vini";
import Home from "./Pages/home";
import ChiSiamo from "./Pages/chiSiamo";
import Olio from "./Pages/olio";
import Gallery from "./Pages/gallery";
function Navigation(){



    return(<>
            <Routes>

            <Route path="/home" element={<ChiSiamo />} />
            <Route path="/vini" element={<Vini />} />
            <Route path="/chiSiamo" element={<ChiSiamo />} />
            <Route path="/index" element={<ChiSiamo />} />
            <Route path="/olio" element={<Olio />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/" element={<Navigate to="/home" />} />
            
            </Routes>

            
    
    
    
    
    </>);
};
export default Navigation;